import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FormattedMessage as Translation } from 'react-intl';
import { Link } from 'react-router-dom';
import withRouter from 'HOCs/withRouter';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import ItemFavouriteIcon from 'Components/ItemFavouriteIcon/ItemFavouriteIcon';
import ItemImage from 'Components/Listing/components/ItemImage';
import CallButton from 'Components/Listing/components/CallButton/CallButton';
import ReactObserver from 'Components/ReactObserver/ReactObserver';
import VasTagsBottomInfo from '../VasTagsBottomInfo/VasTagsBottomInfo';
import withConfig from 'HOCs/withConfig/withConfig';
import withTrack from 'HOCs/withTrack/withTrack';
import withBackButtonHandling from 'HOCs/withBackButtonHandling/withBackButtonHandling';
import useItemInfo from 'Hooks/useItemInfo';
import { getVasConfigValues, getLocale, configSelector } from 'Selectors/config';
import { shortPriceFormat } from 'Helpers/shortPriceDisplay';

import { isCocoFofoUser } from 'Helpers/item';
import { ITEM_SOURCE } from 'Constants/items';
import { LISTING_TYPES, trustTagHash, DEFAULT_SIZE_BY_VISUALIZATION } from 'Constants/listing';
import { SVG_TYPE, WEBP_SVG_TYPE } from 'Constants/images';
import { BLACKBACKGROUND2, MONETIZATIONDARK1 } from 'Constants/colors';
import { fileNames, HIGHLIGHT_TAG } from 'Constants/imageUrls';
import { IS_DESKTOP, IS_MOBILE } from 'Constants/device.APP_TARGET';
import { SELECT_FROM } from 'Constants/tracking';

import { THEMES } from 'Constants/bundles';

import css from './ItemCardCarInd.APP_TARGET.scss';
import isEmpty from 'lodash/isEmpty';
import { isMobile } from 'Helpers/devices';
import SpinViewTag from 'Components/Listing/components/SpinViewTag';
import { CONFIG } from 'Constants/config';
import { FEATURED_TAG } from 'Components/Listing/components/constants';

import { emiNumberFormat } from 'Helpers/emiNumberFormat';
import TooltipInstallment from 'Components/TooltipInstallment/TooltipInstallment';

import MembershipTagV1 from 'Components/MembershipTagV1/MembershipTagV1';
import { getAIGeneratedAdsVideoConfig, showVideoBadgeBasedOnConfig } from 'Helpers/aiGeneratedAdsVideo';
import FeatureBadge from 'Components/FeatureBadge/FeatureBadge';

export const ItemCardCarInd = ({
    userType,
    chosenOption,
    config,
    enabledRealImpressions,
    friendsInCommon,
    isAdSuggested,
    item,
    listingType,
    location,
    onItemClick,
    onView,
    source,
    tag,
    trackerOrigins,
    visualizationType,
    vasConfigValues,
    onVasTagTap,
    track,
    showFullPrice,
    showOlxAutosAdCardTag,
    selectFrom,
    hideVasStrip,
    imageHeight,
    imageWidth,
    generalConfig,
    sellerMembershipType,
    videoBadgeFeatureConfig
}) => {
    const {
        category_id,
        id,
        image,
        isFeatured,
        isInspected,
        isEscrowEnabled,
        price,
        monthly_installment,
        scoreFactor,
        slug,
        spell_id,
        title,
        user_id,
        user_type,
        subtitle,
        make,
        model,
        subDetails,
        isSpinViewAvailable,
        hasPromotion,
        discountedPrice,
        rawPriceValue,
        is_video_generated,
        video_url,
        discountTag
    } = useItemInfo(item, config);
    const adpvConfig = config.get('adpvAuto');
    const showFeaturedTag = adpvConfig?.featuredTag;
    const showFavBtn = adpvConfig?.showFavBtn;
    const hideVasTagListing = config.get('hideVasTagListing');
    const phoneInListing = generalConfig?.features?.find(feature => feature.name === 'olxautos_phone_in_listing') || {};
    const theme = config.get('theme', 'id');
    const staticAsseturl = config.get(CONFIG.STATIC_ASSETS);
    const isOlxMobbi = config.get('isOlxMobbi');

    let status = null;

    if (showFeaturedTag && isFeatured) {
        status = (<ImageWrapper
            fileName={ `${staticAsseturl}/${HIGHLIGHT_TAG}` }
            className={ cx(css.iconSize) }
            alt={ FEATURED_TAG.ALT }
        />);
    }

    const getLinkToProp = () => {
        const state = { isAdSuggested, source, select_from: selectFrom };

        // Add fields for tracking related ads
        if (source === ITEM_SOURCE.RELATED) {
            state.relatedAdTracking = {
                impressions: [{
                    adId: id,
                    scoreFactor: typeof scoreFactor === 'undefined' ? 'null' : scoreFactor
                }],
                chosen_option: typeof chosenOption === 'undefined' ? 'null' : chosenOption,
                origin: trackerOrigins.ITEM_PAGE
            };
        }

        // Add tracking for featured ad
        state.featuredAdTracking = { chosen_option: typeof chosenOption === 'undefined' ? 'null' : chosenOption };

        if (location && location.state && location.state.fromBundleResultset) {
            state.fromBundleResultset = location.state.fromBundleResultset;
        }

        return {
            pathname: slug,
            state
        };
    };

    const onViewChange = inView => {
        if (!enabledRealImpressions) {
            return;
        }
        if (inView) {
            onView({
                id,
                title,
                user_id,
                isFeatured,
                spell_id,
                isInspected
            });
        }
    };
    const onClick = () => onItemClick(item);
    const olxautosTagImage = theme === THEMES.LETGO ? fileNames.OTOPLUS_SMALL_LOGO : fileNames.OLXAUTOS_BLUE_SMALL_LOGO;

    const olxAutosTags = isCocoFofoUser(user_type || userType)
        ? (<ImageWrapper
            fileName={ olxautosTagImage }
            types={ SVG_TYPE }
            className={ css.olxAutosTag }
        />)
        : null;
    const enableCall = isCocoFofoUser(user_type) && phoneInListing.enabled;

    const objInstallment = {
        amount: emiNumberFormat(monthly_installment)
    };
    const contentInstallment = <Translation id="installmentPerMonth" values={ objInstallment } />;

    const listBadge = (
        <div data-aut-id="badgeContainer" className={ cx(css.promotionAdsContainer, { [css.typeVisualizationList]: visualizationType === 'list' }) }>
            {hasPromotion && <FeatureBadge data-aut-id="discountBadge" showIcon className={ css.discountBadgeClass } size={ !isMobile && source === ITEM_SOURCE.BROWSE ? 'lg' : 'sm' } discountText={ `DISKON ${ discountTag || '-'}` } />}
            {isEscrowEnabled && <FeatureBadge data-aut-id="bookingBadge" className={ css.bookingBadge } size={ !isMobile && source === ITEM_SOURCE.BROWSE ? 'lg' : 'sm' } discountText={ 'BOOKING AMAN' } />}
        </div>
    );

    const netPrice = hasPromotion ? discountedPrice : price;

    const isVideoAvailable = is_video_generated && video_url;
    const isSearchPage = source === ITEM_SOURCE.SEARCH || source === ITEM_SOURCE.BROWSE;
    const videoAvailableBadgeSRP = (<ImageWrapper
        addSVG
        types={ WEBP_SVG_TYPE }
        supportForDifferentSize
        className={ css.aiVideoBadgeSRPCLA }
        data-aut-id="vidAvailableSRPCLAsearch"
        fileName={ isMobile ? fileNames.IS_AI_VIDEO_AVAIL_SM : fileNames.IS_AI_VIDEO_AVAIL_LG }
    />);

    return (
        <ReactObserver
            tag={ tag }
            data-aut-id="itemBox"
            data-aut-category-id={ category_id }
            onChange={ onViewChange }
            className={ css[`${visualizationType}ItemCardCarInd`] }>
            <Link
                to={ getLinkToProp() }
                className={ cx({
                    [css.withStatusTagRow]: IS_MOBILE && !olxAutosTags && !status
                }) }
                onClick={ onClick } >
                <div className={ css.topContainer }>
                    {isSpinViewAvailable && <SpinViewTag />}
                    {image
                        && <ItemImage
                            chosenOption={ chosenOption }
                            image={ image }
                            friendsInCommon={ friendsInCommon }
                            defaultSize={ DEFAULT_SIZE_BY_VISUALIZATION[visualizationType] }
                            alt={ title }
                            visualizationType={ visualizationType }
                            listingType={ listingType }
                            height={ imageHeight }
                            width={ imageWidth }
                            topBadgeContent={ hasPromotion || isEscrowEnabled ? listBadge : null }
                            videoAvailableBadge={ showVideoBadgeBasedOnConfig(videoBadgeFeatureConfig, isVideoAvailable, isSearchPage) ? videoAvailableBadgeSRP : null }
                        />
                    }
                    {(IS_DESKTOP || (IS_MOBILE && visualizationType === 'grid'))
                        && showOlxAutosAdCardTag && <div className={ css.statusTags }>
                        {olxAutosTags}
                        {!isOlxMobbi && <MembershipTagV1 type={ sellerMembershipType } containerClassName={ css.membershipTag } iconClassName={ css.iconSize } />}
                        {status}
                    </div>
                    }
                    {
                        listingType === LISTING_TYPES.ITEMS && (
                            <div data-aut-id="itemCardInfo" className={ css.resume }>
                                {IS_MOBILE && visualizationType === 'list'
                                    && showOlxAutosAdCardTag && <div className={ css.statusTags }>
                                    {!isOlxMobbi && <MembershipTagV1 type={ sellerMembershipType } containerClassName={ css.membershipTag } iconClassName={ css.iconSize } />}
                                    {olxAutosTags}
                                    {status}
                                </div>
                                }
                                {price && (
                                    <div className={ css.priceSection }>
                                        <span data-aut-id="itemPrice" className={ cx(css.price, { [css.fullWidth]: showFullPrice }) } >
                                            {netPrice}
                                        </span>
                                        {hasPromotion && <div className={ css.discountSection } data-aut-id="itemDiscountInfo">
                                            <span className={ css.priceBeforeDiscount } data-aut-id="itemPriceBeforeDiscount" >
                                                {shortPriceFormat(rawPriceValue, 'IDR')}
                                            </span>
                                        </div>}
                                    </div>
                                )}

                                {subtitle && !enableCall
                                    && <div className={ css.subTitleSection }>
                                        <div
                                            className={ css.subTitle }
                                            title={ subtitle }
                                            data-aut-id="itemSubTitle"
                                        >
                                            {subtitle}
                                        </div>
                                        {/* OLX AUTOS/Desktop/SRP */}
                                        {(user_type === 'OLX_Autos' || user_type === 'Franchise' || user_type === 'Preferred' || userType === 'OLX_Autos' || userType === 'Franchise' || userType === 'Preferred') && monthly_installment !== 0 ? (
                                            <div className={ css.showInstallment }>
                                                <span className={ css.titleInstallment } data-aut-id="itemInstallment">
                                                    {contentInstallment}
                                                </span>
                                                <span className={ css.tooltipInstallment }>
                                                    <TooltipInstallment item={ item } size={ IS_MOBILE ? 'mobile' : 'large' } track={ track } selectFrom={ SELECT_FROM.LISTING_PAGE } />
                                                </span>
                                            </div>
                                        ) : (
                                            !IS_MOBILE && <div className={ css.noShowInstallments } />
                                        )}
                                    </div>
                                }
                                {make && model
                                    && <div
                                        className={ css.title }
                                        title={ title }
                                        data-aut-id="itemTitle"
                                    >
                                        {`${make} ${model}`}
                                    </div>}
                                {!isEmpty(subDetails) && !enableCall
                                    && <div className={ css.details }
                                        data-aut-id="itemDetails"
                                    >
                                        {subDetails.itemLocation}
                                        {subDetails.displayDate}
                                    </div>
                                }
                                { enableCall && <CallButton phoneNumber={ phoneInListing.data?.number } item={ item } data-aut-id="itemCardCallBtn" />}
                            </div>
                        )
                    }
                </div>
                {listingType === LISTING_TYPES.ITEMS && (
                    <div className={ cx({ [css.vasTagsWrapperHide]: hideVasTagListing || hideVasStrip, [css.vasTagsWrapperShow]: !hideVasTagListing && !hideVasStrip }) } data-aut-id="vas-tags-bottom-info-cont">
                        {!hideVasTagListing && <VasTagsBottomInfo
                            className={ css.bottomCardInfo }
                            itemId={ id }
                            vasConfigValues={ vasConfigValues }
                            gradient={ isCocoFofoUser(user_type || userType) ? MONETIZATIONDARK1 : BLACKBACKGROUND2 }
                            onVasTagTap={ onVasTagTap }
                            onTrack={ track }
                        />}
                    </div>
                )}
            </Link>
            {
                showFavBtn
                    && listingType === LISTING_TYPES.ITEMS
                && <ItemFavouriteIcon
                    item={ item }
                    className={ css.favIcon }
                    btnClassName={ css.favBtn }
                    size={ isMobile ? '14' : '24' }
                    color="white"
                />
            }
        </ReactObserver>
    );
};

ItemCardCarInd.propTypes = {
    userType: PropTypes.string,
    config: PropTypes.object.isRequired,
    item: PropTypes.object,
    onView: PropTypes.func,
    friendsInCommon: PropTypes.bool,
    trackerOrigins: PropTypes.object,
    enabledRealImpressions: PropTypes.bool,
    visualizationType: PropTypes.oneOf([
        'grid', 'big', 'list', 'smallGrid'
    ]),
    listingType: PropTypes.string,
    onItemClick: PropTypes.func,
    tag: PropTypes.string,
    isAdSuggested: PropTypes.bool,
    source: PropTypes.string,
    chosenOption: PropTypes.number,
    location: PropTypes.object,
    vasConfigValues: PropTypes.array,
    onVasTagTap: PropTypes.func,
    track: PropTypes.func.isRequired,
    showFullPrice: PropTypes.bool,
    showOlxAutosAdCardTag: PropTypes.bool,
    selectFrom: PropTypes.string,
    hideVasStrip: PropTypes.bool,
    imageHeight: PropTypes.number,
    imageWidth: PropTypes.number,
    generalConfig: PropTypes.object.isRequired,
    sellerMembershipType: PropTypes.string,
    videoBadgeFeatureConfig: PropTypes.object
};

ItemCardCarInd.defaultProps = {
    userType: '',
    item: {},
    onView: () => { },
    friendsInCommon: false,
    visualizationType: 'grid',
    enabledRealImpressions: false,
    listingType: LISTING_TYPES.ITEMS,
    onItemClick: () => { },
    tag: 'li',
    isAdSuggested: false,
    chosenOption: null,
    trackerOrigins: {},
    vasConfigValues: [],
    financeConfig: {},
    currentLocale: '',
    onVasTagTap: () => {},
    showFullPrice: false,
    showOlxAutosAdCardTag: true,
    hideVasStrip: false,
    videoBadgeFeatureConfig: null
};

export const mapStateToProps = (state, ownProps) => {
    const user = state.users.elements[ownProps.item.user_id];
    const userVasTags = user && user.additional_services || [];

    return {
        userType: user && user.dealer && user.dealer.car && user.dealer.car.dealer_type || '',
        currentLocale: getLocale(state),
        selectFrom: (ownProps.location.state && ownProps.location.state.source),
        vasConfigValues: getVasConfigValues(state, ownProps.item.vasTags || userVasTags || []),
        financeConfig: state.financeConfig || {},
        generalConfig: configSelector(state),
        videoBadgeFeatureConfig: getAIGeneratedAdsVideoConfig(configSelector(state).features)
    };
};

export default compose(
    withConfig,
    withTrack,
    withRouter,
    withBackButtonHandling(trustTagHash),
    connect(mapStateToProps, null)
)(ItemCardCarInd);
